/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';

import {batch, connect} from 'react-redux';

import {updateLoading} from '@/actions/loadingActions';
import {postCancelSensorCheck} from '@/api/concentratorApi';
import {eventBusObject} from '@/observers/eventBus';

import DeviceElementAvailability, {DeviceElementAvailabilityEvent} from './DeviceElementAvailability';
import TubeAvailabilityCheck, {TubeAvailabilityCheckEvent} from './TubeAvailabilityCheck';
import VolumeSensorReadlines, {VolumeSensorReadlinesEvent} from './VolumeSensorReadlines';
import VolumeSensorStability, {VolumeSensorStabilityEvent} from './VolumeSensorStability';

@connect((store) => ({
  isScheduleWillRun: store.schedulerState.isScheduleWillRun,
}))
class PreCheckRunningProfile extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
    this._bus = eventBusObject();
    this._deviceElementCheckList = [];
    this._isRunLater = false;
    this._startDate = false;
    this._relativeTime = false;
    this._scheduleType = false;
    this.recheckAvailability = false;
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.isScheduleWillRun !== prevState.isScheduleWillRun) {
      return {
        isScheduleWillRun: nextProps.isScheduleWillRun,
      };
    }

    return null;
  }

  componentDidMount() {
    this.eventPreCheck = this._bus.subscribe(PreCheckRunningProfileEvent.RUN_PRE_CHECK, (param) => {
      this.startPreCheck(param);
    });
  }

  componentWillUnmount() {
    this.eventPreCheck.unsubscribe();
  }

  setRecheckAvailability = (value) => {
    this.recheckAvailability = value;
  };

  // eslint-disable-next-line class-methods-use-this
  forceCancelPreCheck = () => {
    batch(() => {
      postCancelSensorCheck();
      this.props.dispatch(
        updateLoading({
          showLoading: false,
          loadingText: '',
        }),
      );
    });
  };

  startPreCheck = (param) => {
    // this._bus.publish(TubeAvailabilityCheckEvent.TUBE_AVAILABILITY,"")
    this._bus.publish(DeviceElementAvailabilityEvent.ELEMENT_AVAILABILITY, '');
    this._isRunLater = param?.isRunLater;
    this._startDate = param?.startDate;
    this._relativeTime = param?.relativeTime;
    this._scheduleType = param?.scheduleType;
    // this._bus.publish(VolumeSensorReadlinesEvent.VOLUME_SENSOR_READLINES,"")
  };

  ProfileIsReadyToRun = () => {
    const param = {
      DeviceElementCheckList: this._deviceElementCheckList,
      isRunLater: this._isRunLater,
      startDate: this._startDate,
      relativeTime: this._relativeTime,
      scheduleType: this._scheduleType,
    };
    this.props.callbackReadyToAutoRun(param);
  };

  // TO DO :  Create checker for all Pre check running profile is done or not
  deviceElementAvailability = (elementCheckList) => {
    if (this.props.isScheduleWillRun) {
      this.forceCancelPreCheck();
    } else {
      this._bus.publish(TubeAvailabilityCheckEvent.TUBE_AVAILABILITY, '');
      this._deviceElementCheckList = elementCheckList;
    }
  };

  tubeAvailable = () => {
    if (this.props.isScheduleWillRun) {
      this.forceCancelPreCheck();
    } else {
      this._bus.publish(VolumeSensorReadlinesEvent.VOLUME_SENSOR_READLINES, '');
    }
  };

  volumeSensorReady = () => {
    if (this.props.isScheduleWillRun) {
      this.forceCancelPreCheck();
    } else {
      this._bus.publish(VolumeSensorStabilityEvent.VOLUME_SENSOR_STABILITY, '');
    }
  };

  VolumeSensorStability = () => {
    if (this.recheckAvailability) {
      this.recheckAvailability = false;
      this.startPreCheck();
    } else {
      this.ProfileIsReadyToRun();
    }
  };

  render() {
    return (
      <>
        <DeviceElementAvailability callbackDeviceElementAvailability={this.deviceElementAvailability} />
        <TubeAvailabilityCheck
          callbackTubeAvailable={this.tubeAvailable}
          setRecheckAvailability={this.setRecheckAvailability}
        />
        <VolumeSensorReadlines callbackVolumeSensorReady={this.volumeSensorReady} />
        <VolumeSensorStability callbackVolumeSensorStability={this.VolumeSensorStability} />
      </>
    );
  }
}

export default PreCheckRunningProfile;

export const PreCheckRunningProfileEvent = {
  RUN_PRE_CHECK: 'RUN_PRE_CHECK',
};
